import Vue from 'vue'
import Vuex from 'vuex'
import { server } from '@/utils/http-service.js'//引用了封装axios文件
import { Message } from 'element-ui'
import {util} from '@/utils/util'//引用了封装axios文件

Vue.use(Vuex)


export const store = new Vuex.Store({
  state: {
    languageType: util.defLanguage=='zh'?'0':'1',
    provinceList: [],
    cityList: [],
    areaList: [],
    buildingList: [],
    roomTypeList: [],
    gatewayList:[],
    gatewayDetail:{},
    apartmetnData:[],
    apartmentBuilds:[]
  },
  // 更改store的状态
  mutations: {
    province(state, obj) {
      var formData = new FormData();
      server.exam("/customer/search/getAreaProvice", formData)
        .then(data => {
          if (data.code == 200) {
            state.provinceList = data.data
          } else {
            Message({
              message: data.message,
              type: 'error'
            })
          }
        });
    },
    city(state, obj) {
      var formData = new FormData();
      formData.append("provinceCode", obj.provinceCode==null?'':obj.provinceCode);
      server.exam("/customer/search/getAreaCity", formData)
        .then(data => {
          if (data.code == 200) {
            state.cityList = data.data
          } else {
            Message({
              message: data.message,
              type: 'error'
            })
          }
        });
    },
    area(state, obj) {
      var formData = new FormData();
      formData.append("cityCode", obj.cityCode==null?'':obj.cityCode);
      server.exam("/customer/search/getAreaArea", formData)
        .then(data => {
          if (data.code == 200) {
            state.areaList = data.data
          } else {
            Message({
              message: data.message,
              type: 'error'
            })
          }
        });
    },

    buildings(state, obj) {
      var formData = new FormData();
      formData.append("apartmentId", obj.apartmentId);
      server.exam("/customer/apartment/listApartmentBuilding", formData)
        .then(data => {
          if (data.code == 200) {
            state.buildingList = data.data
          } else {
            Message({
              message: data.message,
              type: 'error'
            })
          }
        });
    },
    
    roomType(state, obj) {
      var formData = new FormData();
      if(obj.apartmentId!=""&&obj.apartmentId!=null&&obj.apartmentId!=undefined){
        formData.append("apartmentId",obj.apartmentId);
      }
      server.exam("/customer/apartment/listApartmentRoomType", formData)
        .then(data => {
          if (data.code == 200) {
            state.roomTypeList = data.data
          } else {
            Message({
              message: data.message,
              type: 'error'
            })
          }
        });
    },
    
    getApartmentDetail(state, obj){
      var formData = new FormData();
      formData.append("apartmentId",obj.apartmentId);
      if(obj.roomName!=""&&obj.roomName!=null&&obj.roomName!=undefined){
        formData.append("roomName",obj.roomName);
      }
      if(obj.isBindDevice!=""&&obj.isBindDevice!=null&&obj.isBindDevice!=undefined){
        formData.append("isBindDevice",obj.isBindDevice);
      }
      if(obj.status!=""&&obj.status!=null&&obj.status!=undefined){
        formData.append("status",obj.status);
      }
      server.exam("/customer/apartment/getApartmentDetail", formData)
        .then(d => {
          if (d.code == 200) {
            state.apartmetnData=d.data;
            var apmData = d.data.buildingDetailList;
            state.apartmentBuilds = apmData;
          } else {
            state.apartmentBuilds ="";//有可能未授权
            Message({
              message: d.message,
              type: "warning"
            });
          }
        });
    },

    getGatewayDetail(state, obj) {
      var formData = new FormData();
      formData.append("deviceId", obj.deviceId);
      server.exam("/customer/apartment/getGatewayDetail", formData)
        .then(data => {
          if (data.code == 200) {
            state.gatewayDetail = data.data;
          } else {
            state.gatewayDetail={};
            Message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

    getApartmentRoomUsableGateway(state, obj) {
      var formData = new FormData();
      formData.append("roomId", obj.roomId);
      // formData.append("deviceType",obj.deviceType);
      server.exam("/customer/apartment/getApartmentRoomUsableGateway", formData)
        .then(data => {
          if (data.code == 200) {
            obj.this.gatewayPageData.gatewayData = data.data;
            obj.this.bindDeviceForm.gatewayData=data.data;
          } else {
            Message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

    getBindFirstDevice(state, obj) {
      var formData = new FormData();
      formData.append("apartmentId", obj.apartmentId);
      formData.append("deviceType",obj.deviceType);
      server.exam("/customer/apartment/getApartmentBindDevice", formData)
        .then(data => {
          if (data.code == 200) {
            state.gatewayList = data.data;
          } else {
            Message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

  },
  // 有异步的时候， 需要action
  actions: {
    checkResult(state, obj) {
      var time1 = new Date().getTime();
      var time2 = 0;
      var errTxt = "";
      var formData = new FormData();
      formData.append("recordId", obj.rId);
      var interval = setInterval(function () {
        time2 = new Date().getTime();
        console.log(time2 - time1);
        if (time2 - time1 > 23000) {
          clearInterval(interval);
          obj.loading.close();
          Message({
            message: "操作超时",
            type: 'error'
          })
          return false;
        } else {
          server.exam("/customer/search/checkAsynRequestResult", formData).then(data => {
            if (data.code == 200) {
              var ajaxData = data['data'];
              switch (ajaxData['handleResult']) {
                case -1:
                  break;
                case 0:
                  clearInterval(interval);
                  errTxt = ajaxData['returnMessage'];
                  obj.loading.close();
                  Message({
                    message: errTxt,
                    type: 'error'
                  })
                  break;
                case 1:
                  clearInterval(interval);
                  errTxt = ajaxData['returnMessage'];
                  obj.loading.close();
                  Message({
                    message: errTxt,
                    type: 'success'
                  })
                  switch(obj.opType){
                     case "addGateway"://绑定网关
                        var json={};
                        json.roomId=obj.roomId;
                        // json.apartmentId=obj.apartmentId;
                        // json.deviceType=0
                        // store.commit('getApartmentRoomUsableGateway',json)
                        obj.this.getGatewayPageList();
                       break;
                      case "unbindGateway"://解绑网关
                        // store.commit('getGatewayDetail',{deviceId: obj.deviceId})
                        obj.othis.$mainInfo.removeTab(obj.tabIndex);
                        var gjson={};
                        gjson.roomId=obj.roomId;
                        store.commit('getApartmentRoomUsableGateway',gjson)
                        var json={};
                        json.apartmentId=obj.apartmentId;
                        store.commit("getApartmentDetail",json);
                        break 
                      case "netLock"://绑定联网锁
                        switch(obj.deviceType){
                           case 1:
                             obj.othis.addNetLockVisible=false;
                             break;
                           case 3:
                             obj.othis.addNBNetLockVisible=false;
                             break;  
                           case 5:
                              obj.othis.add4GNetLockVisible=false;
                             break;   
                        }
                       
                        var json={};
                        json.apartmentId=obj.apartmentId;
                        store.commit("getApartmentDetail",json);
                        obj.othis.power();
                        var sonTabsItem = obj.othis.sonTabsItem;
                          for (var str in sonTabsItem) {
                            if (sonTabsItem[str].apartmentId == obj.othis.infoData.apartmentId) {
                              var temp = sonTabsItem[str].tabsItem;
                              var strItem = [];
                              for (var s in temp) {
                                if (temp[s].id == obj.othis.currRoomData.roomId) {
                                  var objt={};
                                  objt.deviceId=obj.othis.offlineForm.lockId;
                                  objt.deviceName=obj.othis.offlineForm.lockName;
                                  objt.deviceType=obj.deviceType;
                                  objt.offLineLockType=1//7位锁码
                                  temp[s].ref.deviceList.push(objt);
                                }
                              }
                            }
                          }
                        break
                      case "unbindNetLock"://解绑联网锁
                        obj.othis.dialogVisible=false;
                        var json={};
                        json.apartmentId=obj.apartmentId;
                        store.commit("getApartmentDetail",json);
                        obj.othis.$mainInfo.removeTab(obj.tabIndex);
                        break; 
                      case "openLock"://开锁
                        
                        break; 
                      case "setLockTime":
                        // Message({
                        //   message: ajaxData.returnMessage,
                        //   type: "warning"
                        // });
                        break
                      case "getLockTime":
                          // Message({
                          //   message: ajaxData.returnMessage,
                          //   type: "success"
                          // });
                        break  
                      case "getLockVersion":
                          // Message({
                          //   message: ajaxData.returnMessage,
                          //   type: "success"
                          // });
                        break  
                      case "upgradeDevice":
                          // Message({
                          //   message: ajaxData.returnMessage,
                          //   type: "success"
                          // });
                        break    
                      case "seeLockTime":
                        Message({
                          message: ajaxData.returnMessage,
                          type: "success"
                        });
                        break;  
                      case "checkIn"://入住
                        obj.othis.tenantInfoVisible=false;
                        var json={};
                        json.apartmentId=obj.apartmentId;
                        store.commit("getApartmentDetail",json);
                        break;    
                      case "checkOut"://退房
                        obj.othis.tenantInfoVisible=false;
                        var json={};
                        json.apartmentId=obj.apartmentId;
                        store.commit("getApartmentDetail",json);
                        break 
                      case "addNetLockAuth"://增加联网锁授权
                        var json={};
                        json.apartmentId=obj.apartmentId;
                        obj.othis.authPower();
                        break;
                      case "delNetLockAuth":
                        var json={};
                        json.apartmentId=obj.apartmentId;
                        obj.othis.authPower();
                        break;  
                      case "tenantDetailCheckIn":
                        obj.othis.tenantInfoVisible=false;
                        obj.othis.getTenantDetail(obj.tenantId);
                        var json={};
                        json.apartmentId=obj.apartmentId;
                        store.commit("getApartmentDetail",json);
                        break
                      case "tenantListCheckIn":
                        obj.othis.addTenantVisible=false;
                        obj.othis.power();
                        break;     
                      case "addFgDevice":
                        obj.othis.getFgPageList();
                        obj.loading.close();
                        obj.othis.addDeviceFlag=false;
                        break;
                      case "collectUserFingerprint":
                        var fgData=JSON.parse(ajaxData.callbackResult);
                        var extendsData=JSON.parse(fgData.extendsData);
                        console.log(extendsData.fingerprintId);
                        obj.loading.close();
                        obj.othis.addFgDevice.fingerprintId=extendsData.fingerprintId;
                        Message({
                          message: "采集成功",
                          type: 'success'
                        })
                        break;
                      case "collectTenantFingerprint":
                          var fgData=JSON.parse(ajaxData.callbackResult);
                          var extendsData=JSON.parse(fgData.extendsData);
                          console.log(extendsData.fingerprintId);
                          obj.loading.close();
                          obj.othis.formTenant.fingerprintId=extendsData.fingerprintId;
                          Message({
                            message: "采集成功",
                            type: 'success'
                          })
                        break;  
                      case "addEndDevice":
                        obj.othis.getLockPageList();
                        obj.loading.close();
                        obj.othis.bindDeviceVisible=false;
                        break;
                      case "netLockBind":
                        obj.othis.getLockPageList();
                        obj.loading.close();
                        obj.othis.bindDeviceVisible=false;
                        break;         
                  }
                  break;
                case 2:
                  break;
              }

            } else {
              Message({
                message: data.message,
                type: "warning"
              });
            }
          })
        }
      }, 2000);
    }
  },
  // 通过getter 进行数据获取
  getters: {
  }
})


// WEBPACK FOOTER //
// ./src/store/store.js